import { Directory, getUserFields } from "./directory.store";

export function resetDirectoryFilters() {
    Directory.Filter = {
        userFields: getUserFields(),
        agents: [],
        "pageNum": "1",
        "sort": { "address1": "-1" },
        "filter": { "type": "", "userSubType": [] },
        "email": "",
        "name": "",
        "address1": "",
        "type": "",
        "mobile": "",
        "designation": "",
        "missingDetails": '',
        location: [],
        ageGroup: [],
        gender: ''
    }
}
export function getNewDirectoryFilter(){
    return {
        userFields: getUserFields(),
        agents: [],
        "pageNum": "1",
        "sort": { "address1": "-1" },
        "filter": { "type": "", "userSubType": [] },
        "email": "",
        "name": "",
        "address1": "",
        "type": "",
        "mobile": "",
        "designation": "",
        "missingDetails": '',
        location: [],
        ageGroup: [],
        gender: ''
    }
}